import { Icon } from '@sleepstation/components'
import { HLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING, SIZE } from '@sleepstation/const'
import { baseline, themeFontBody } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HLayout).attrs({
  spacing: LAYOUT_SPACING.MEDIUM,
  align: LAYOUT_ALIGN.TOP,
})`
  > *:first-child {
    position: relative;
    top: 0.4em;
  }
`

const Label = styled.div`
  ${themeFontBody()}
  ${baseline(0)}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const LevelListItem = ({ range, label, level }) => (
  <Layout>
    <Icon name="placeholder" type={level} size={SIZE.SMALL} />
    <Label>
      <strong>{range}</strong> {label}
    </Label>
  </Layout>
)

LevelListItem.propTypes = {
  range: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
}

export default LevelListItem
